import { Auth0Client } from "@auth0/auth0-spa-js";

const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN;
const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const auth0Audience = import.meta.env.VITE_AUTH0_AUDIENCE;

if (!auth0Domain || !auth0ClientId) {
  throw new Error("Missing Auth0 environment variables");
}

export const auth0Client = new Auth0Client({
  domain: auth0Domain,
  clientId: auth0ClientId,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: auth0Audience,
  },
});

// Non-hook token getter for usage outside React components/hooks
export async function getAccessTokenDirect(): Promise<string> {
  return await auth0Client.getTokenSilently();
}
